import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const PrizeDrawsSection = () => (
  <>
    <SectionHeading>Prize Draws</SectionHeading>

    <ListItem marker="(a)" withBottomMargin>
      {"In respect of any prize draw, if and where applicable, Winners will be drawn at random from all entries correctly submitted and, provided all players are Qualifying Players, no favoritism will be shown in terms of gender, age, geographic location, length of time as a Qualifying Player, which of Our gaming channels or Platforms a Qualifying Player has used, or any other factor."}
    </ListItem>
  </>
);

export default PrizeDrawsSection;
